import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useToast } from '../hooks/use-toast';

const Footer = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [agreed, setAgreed] = useState(false);

  const subscribe = (e) => {
    e.preventDefault();
    if (!email || !agreed) {
      toast({ title: 'Almost there', description: 'Add your email and confirm the checkbox to subscribe.' });
      return;
    }
    toast({ title: 'Subscribed', description: "You're on the list. Thanks for joining." });
    setEmail('');
    setAgreed(false);
  };

  return (
    <footer className="bg-neutral-950 text-neutral-300">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
          className="grid md:grid-cols-2 gap-12 md:gap-16"
        >
          <div>
            <div className="font-display text-[20px] font-medium text-white">Bio & Chem with Hamza</div>
            <div className="mt-10 text-[13px] text-neutral-400 leading-[1.7]">
              <div>munumhamza81@gmail.com</div>
              <div>+44 07305 703314</div>
            </div>
          </div>

          <div>
            <div className="text-[14px] text-white font-medium">Stay informed.</div>
            <form onSubmit={subscribe} className="mt-6 space-y-4">
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full bg-transparent border-b border-neutral-700 focus:border-white py-2 outline-none text-white text-[14px] transition-colors"
              />
              <label className="flex items-start gap-2 text-[12px] text-neutral-400 cursor-pointer">
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  className="mt-0.5 accent-white"
                />
                <span>Yes, subscribe me to your newsletter.</span>
              </label>
              <motion.button
                type="submit"
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                className="w-full bg-white text-neutral-900 py-3 text-[13px] font-medium rounded-md hover:bg-neutral-200 transition-colors"
              >
                Subscribe
              </motion.button>
            </form>
          </div>
        </motion.div>

        <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[12px] text-neutral-500">
          <div>© {new Date().getFullYear()} Bio & Chem with Hamza. All rights reserved.</div>
          <div>Designed with care — inspired by the original Canva design.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
